module.exports = __webpack_public_path__ + "static/media/Manual_Product_Set_Up.1d90ae7e.png";